<template>
  <material-card :color="titleColor"
                 :title="$t('my_schedule_view.title')"
                 :text="$t('my_schedule_view.subtitle_table')">


    <ProgressBar :loading="tableData.length == 0" color="deep-purple accent-4" />

    <v-layout row>
      <v-flex xs3>
        <slot name="actions"></slot>
      </v-flex>

    </v-layout>

    <v-data-table :headers="headers1()"
                  :items="tableData"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  class="v-icon-fix"
                  pagination.sync="pagination">

      <template slot="headerCell"
                slot-scope="{ header }">
        <span class="font-weight-light text-warning text--darken-3"
              v-text="header.text" />
      </template>

      <template slot="items"
                slot-scope="{ index, item }">
        <!--<td>{{ index + 1 }}</td>-->
        <td>{{ item.Datum | moment("DD.MM.YYYY.") }} <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ({{item.TerminOd | moment("HH:mm")}} - {{item.TerminDo | moment("HH:mm")}}) </td>
        <td class="text-xs-left">
          <ul>
            <li></li>
            <li>{{item.Ime}}</li>
          </ul>
        </td>
        <td>
          {{item.UcionicaNaziv}}, {{item.UcionicaUlica}}, {{item.UcionicaGrad}}
        </td>
      </template>
    </v-data-table>
  </material-card>
</template>


<script>
  export default {
    name: 'MyScheduleTableComp',
    props: {
      titleColor: '',
      tableData: { type: Array, default: [] },
    },
    data() {
      return {
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false
        },

        pagination: {
          rowsPerPage: 10
        }
      }
    },

    methods: {
      headers1() {
        return [
          //{
          //  sortable: false,
          //  text: 'ID',
          //  value: 'id'
          //},
          {
            sortable: false,
            text: this.$t('my_schedule_view.table_view_headers.event_date'),
            value: 'Datum'
          },
          {
            sortable: false,
            text: this.$t('my_schedule_view.table_view_headers.seminar'),
            value: 'Seminar',
            align: 'left'
          },
          {
            sortable: false,
            text: this.$t('my_schedule_view.table_view_headers.classroom'),
            value: 'Ucionica',
            align: 'left'
          },

        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Education/schedule_components/MyScheduleTableComp.vue